// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#embed-host {
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 10;
}

#__resizable_base__ {
  display: none;
}

#embed {
  background: #333333;
  height: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-rows: 30px 1fr;
  font: 14px "Arial";
  overflow: hidden;
}
#embed #header {
  font-size: 16px;
  color: white;
  background: #222222;
  grid-row: 1;
  text-align: center;
  display: grid;
  grid-template-columns: 30px 1fr 50px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#embed #header #logo {
  grid-column: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-self: center;
  justify-self: center;
}
#embed #header #back {
  grid-column: 1;
  display: grid;
  align-self: center;
  justify-self: center;
  cursor: pointer;
}
#embed #header #title {
  grid-column: 2;
  display: grid;
  align-items: center;
  text-align: center;
}
#embed #header #commands {
  grid-column: 3;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}
#embed #header #commands .expand {
  grid-column: 1;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#embed #header #commands .close {
  grid-column: 2;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#embed #split {
  grid-row: 2;
  overflow: hidden;
}
#embed #split.splitPopup {
  display: grid;
  grid-template-rows: 300px 2px 1fr;
}
#embed #split.splitPopup .panes {
  margin-bottom: 1px;
}
#embed #split #topPart {
  grid-row: 1;
  overflow: hidden;
  display: grid;
  grid-auto-rows: 100%;
}
#embed #split #separator {
  grid-row: 2;
  background: white;
  opacity: 0.1;
}
#embed #split #bottomPart {
  overflow: hidden;
  grid-row: 3;
  display: grid;
  grid-auto-rows: 100%;
}
#embed #split .gutter.gutter-vertical {
  background-image: none;
  background: #444444;
  cursor: row-resize;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/embedHost/embedHost.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AACR;AACQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AACZ;AAEQ;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAAZ;AAGQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AADZ;AAIQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFZ;AAIY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAFhB;AAKY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAHhB;AAQI;EACI,WAAA;EACA,gBAAA;AANR;AAQQ;EACI,aAAA;EACA,iCAAA;AANZ;AAQY;EACI,kBAAA;AANhB;AAUQ;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AARZ;AAWQ;EACI,WAAA;EACA,iBAAA;EACA,YAAA;AATZ;AAYQ;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;AAVZ;AAaQ;EACI,sBAAA;EACA,mBAAA;EACA,kBAAA;AAXZ","sourcesContent":["#embed-host {\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    z-index: 10;\r\n}\r\n\r\n#__resizable_base__ {\r\n    display: none;\r\n}\r\n\r\n#embed {\r\n    background: #333333;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-rows: 30px 1fr;\r\n    font: 14px \"Arial\";\r\n    overflow: hidden;\r\n\r\n    #header {\r\n        font-size: 16px;\r\n        color: white;\r\n        background: #222222;\r\n        grid-row: 1;\r\n        text-align: center;\r\n        display: grid;\r\n        grid-template-columns: 30px 1fr 50px;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n\r\n        #logo {\r\n            grid-column: 1;\r\n            width: 24px;\r\n            height: 24px;\r\n            display: flex;\r\n            align-self: center;\r\n            justify-self: center;\r\n        }\r\n\r\n        #back {\r\n            grid-column: 1;\r\n            display: grid;\r\n            align-self: center;\r\n            justify-self: center;\r\n            cursor: pointer;\r\n        }\r\n\r\n        #title {\r\n            grid-column: 2;\r\n            display: grid;\r\n            align-items: center;\r\n            text-align: center;\r\n        }\r\n\r\n        #commands {\r\n            grid-column: 3;\r\n            display: grid;\r\n            align-items: center;\r\n            grid-template-columns: 1fr 1fr;\r\n\r\n            .expand {\r\n                grid-column: 1;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n\r\n            .close {\r\n                grid-column: 2;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    #split {\r\n        grid-row: 2;\r\n        overflow: hidden;\r\n\r\n        &.splitPopup {\r\n            display: grid;\r\n            grid-template-rows: 300px 2px 1fr;\r\n\r\n            .panes {\r\n                margin-bottom: 1px;\r\n            }\r\n        }\r\n\r\n        #topPart {\r\n            grid-row: 1;\r\n            overflow: hidden;\r\n            display: grid;\r\n            grid-auto-rows: 100%;\r\n        }\r\n\r\n        #separator {\r\n            grid-row: 2;\r\n            background: white;\r\n            opacity: 0.1;\r\n        }\r\n\r\n        #bottomPart {\r\n            overflow: hidden;\r\n            grid-row: 3;\r\n            display: grid;\r\n            grid-auto-rows: 100%;\r\n        }\r\n\r\n        .gutter.gutter-vertical {\r\n            background-image: none;\r\n            background: #444444;\r\n            cursor: row-resize;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
